export default "__VITE_ASSET__7646879d__"